<template>
  <div>
    <ul v-if="field.$error" class="errors mt-1">
      <li v-if="invalid('email')">
        {{ $t('validators.email') }}
      </li>
      <li v-if="invalid('maxLength')">
        {{ $t('validators.maxLength', { max: field.maxLength.$params.max }) }}
      </li>
      <li v-if="invalid('minLength')">
        {{ $t('validators.minLength', { min: field.minLength.$params.min }) }}
      </li>
      <li v-if="invalid('maxDecimal')">
        {{ $t('validators.maxDecimal', { max: field.maxDecimal.$params.max }) }}
      </li>
      <li v-if="invalid('required')">
        {{ $t('validators.required') }}
      </li>
      <li v-if="invalid('url')">
        {{ $t('validators.url') }}
      </li>
      <li v-if="invalid('sameAsPassword')">
        {{ $t('validators.sameAsPassword') }}
      </li>
      <li v-if="invalid('maxValue')">
        {{ $t('validators.maxValue', { max: field.maxValue.$params.max }) }}
      </li>
      <li v-if="invalid('minValue')">
        {{ $t('validators.minValue', { min: field.minValue.$params.min }) }}
      </li>
      <li v-if="invalid('areaCode')">
        {{ $t('validators.areaCode') }}
      </li>
      <li v-if="invalid('ssn')">
        {{ $t('validators.ssn') }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    field: {
      type: Object,
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    hasValidator(validator) {
      return this.field.hasOwnProperty(validator);
    },
    invalid(validator) {
      return this.hasValidator(validator) && this.field[validator].$invalid;
    }
  }
};
</script>
<style lang="scss" scoped>
ul.errors {
  li {
    color: red;
  }
}
</style>
